/**
 * @generated SignedSource<<7a9b6f3a5fca0bb2446c412ef968c9d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateProjectPurchaseOrderReferenceInput = {
  id: string;
  purchaseOrderReference: string;
};
export type ProjectDetailsViewUpdateProjectPurchaseOrderReferenceMutation$variables = {
  input: UpdateProjectPurchaseOrderReferenceInput;
};
export type ProjectDetailsViewUpdateProjectPurchaseOrderReferenceMutation$data = {
  readonly updateProjectPurchaseOrderReference: {
    readonly id: string;
    readonly purchaseOrderReference: string | null | undefined;
  };
};
export type ProjectDetailsViewUpdateProjectPurchaseOrderReferenceMutation = {
  response: ProjectDetailsViewUpdateProjectPurchaseOrderReferenceMutation$data;
  variables: ProjectDetailsViewUpdateProjectPurchaseOrderReferenceMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Project",
    "kind": "LinkedField",
    "name": "updateProjectPurchaseOrderReference",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "purchaseOrderReference",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectDetailsViewUpdateProjectPurchaseOrderReferenceMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectDetailsViewUpdateProjectPurchaseOrderReferenceMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4d4e1081dd7d948d23d51adba6472f6c",
    "id": null,
    "metadata": {},
    "name": "ProjectDetailsViewUpdateProjectPurchaseOrderReferenceMutation",
    "operationKind": "mutation",
    "text": "mutation ProjectDetailsViewUpdateProjectPurchaseOrderReferenceMutation(\n  $input: UpdateProjectPurchaseOrderReferenceInput!\n) {\n  updateProjectPurchaseOrderReference(input: $input) {\n    id\n    purchaseOrderReference\n  }\n}\n"
  }
};
})();

(node as any).hash = "55ad239ade79dabac7b7eefc7634a086";

export default node;
